import * as React from 'react';
import { connect } from 'react-redux';

import { Carousel } from '../../components/Carousel';
import { Container } from '../../components/Container';
import { PromoBlock } from '../../components/PromoBlock';
import {
  SIZE_12, SIZE_16, SIZE_20, SIZE_8, SIZE_4, SIZE_160, SIZE_204,
  SIZE_272, SIZE_216, SIZE_40,
} from '../../constants/sizes';
import { Text } from '../../components/Text';
import { Image } from '../../components/Image';
import { INewbuilding, IImageInfo, IRoom } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';
import { ISlideProps } from '../../components/Carousel/Carousel';
import { Link } from '../../components/Link';
import { isNewbuildingInLeadFactory } from '../../utils/helpers';
import { CianInfo } from './CianInfo';
import { getMetroInfo } from './getMetroInfo';
import { Advertises } from './Advertise';
import { FavoriteButton } from './FavoriteButton';
import { RoomCounts } from './RoomCounts';
import { BuilderInfo } from './BuilderInfo';
import { ReliableChoicePopup } from '../ReliableChoicePopup';
import { ShowPhoneButtonContainer } from './ShowPhoneButtonContainer';
import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionShowPhone } from '../../actions/analytics';
import { SPACE_SYMBOL, NO_BREAK_SPACE, MIDDLE_DOT } from '../../constants/symbolsUnicode';
import { NewbuildingFeatures } from '../../components/NewbuildingFeatures';
import { SalesLeader } from '../../components/SalesLeader';
import { getGeoDistance } from './getGeoDistance';
import { ProblemNewbuildingPopup } from '../../components/ProblemNewbuildingPopup';
import { isEmptyArray } from '../../utils/isEmptyArray';

interface IGKCardOwnProps {
  newbuilding: INewbuilding;
  onPhoneButtonClick(): void;
  trackingOnCardClick(): void;
  isEven: boolean;
}

interface IGKCardStoreProps {
  rooms?: IRoom[];
  isMobile: boolean;
  salesLeaderFullUrl: string;
  urlFinisher?: string;
}

interface IGKDispatchProps {
  trackingOnPhoneClick(): void;
}

type TGKCardProps = IGKCardOwnProps & IGKCardStoreProps & IGKDispatchProps;

export class GKCardComponent extends React.PureComponent<TGKCardProps> {
  public preloadLink: HTMLLinkElement;

  public componentDidMount() {
    this.preloadLink = document.createElement('link');
    this.preloadLink.setAttribute('rel', 'preconnect');
    this.preloadLink.setAttribute('href', this.props.newbuilding.url);
    document.head.appendChild(this.preloadLink);
  }
  public componentWillUnmount() {
    document.head.removeChild(this.preloadLink);
  }
  public render() {
    const {
      isEven = false,
      newbuilding,
      salesLeaderFullUrl,
      onPhoneButtonClick,
      trackingOnPhoneClick,
      urlFinisher,
    } = this.props;

    return (
      <Container
        dataMark="GKCard"
        key={newbuilding.id}
        padding={`${SIZE_16} ${SIZE_20} ${SIZE_12}`}
        borderStyle="solid"
        borderColor="gray_1"
        borderBottomWidth={1}
        borderTopWidth={0}
        borderLeftWidth={0}
        borderRightWidth={0}
        display="flex"
        justifyContent="space-between"
        dataId={isEven ? 'gk_card_even' : 'gk_card_odd'}
        printBreakInsideAvoid
      >
        <Container
          height={SIZE_204}
          width={SIZE_272}
          position="relative"
          flex="0 0 auto"
        >
          {newbuilding.images.length
            ? <Carousel
              slides={newbuilding.images.map(
                (img: IImageInfo, index: number) =>
                  ({ visible }: ISlideProps) =>
                    visible && <Image
                          alt={`${index + 1}-я Фотография ${newbuilding.displayName || newbuilding.name}`}
                          src={img.thumbnailUrl}
                          lazy
                          loading="lazy"
                      />,
              )}
              defaultSlideIndex={newbuilding.images.findIndex((img: IImageInfo) => img.isDefault)}
            />
            : <Image />
          }

          {!isEmptyArray(newbuilding.promoInfoList) &&
          <PromoBlock promos={newbuilding.promoInfoList} url={newbuilding.url} />
          }
          <NewbuildingFeatures
            newbuilding={newbuilding}
          />
        </Container>
        <Container
          flex="1 1 100%"
          padding={`0 ${SIZE_16}`}
        >
          <Container>
            <Container
              padding={`${SIZE_4} ${SIZE_12} 0 0`}
              display="inline-block"
              dataMark="GKCardTitle"
            >
              <Link
                url={newbuilding.url}
                onClick={this.props.trackingOnCardClick}
                target="blank"
              >
                <Text
                  color="blue"
                  fontSize={18}
                  lineHeight={22}
                  fontWeight="bold"
                  colorHovered="red"
                >
                  {newbuilding.displayName || newbuilding.name}
                </Text>
              </Link>
            </Container>
            {newbuilding.showReliableFlag && !!newbuilding.url &&
            <Container
              padding={`0 ${SIZE_12} 0 0`}
              display="inline"
            >
              <ReliableChoicePopup url={newbuilding.url} GKId={newbuilding.id} />
            </Container>
            }
            {newbuilding.isSalesLeader && !!salesLeaderFullUrl &&
            <Container
              padding={`0 ${SIZE_12} 0 0`}
              display="inline"
            >
              <SalesLeader salesLeaderFullUrl={salesLeaderFullUrl} />
            </Container>
            }
            {newbuilding.isProblem && !!newbuilding.url &&
            <Container
              padding={`0 ${SIZE_12} 0 0`}
              display="inline"
            >
              <ProblemNewbuildingPopup url={newbuilding.url} GKId={newbuilding.id} />
            </Container>
            }
          </Container>
          <Container
            margin={`0 0 ${SIZE_8}`}
          >
            <Text
              fontSize={14}
              lineHeight={18}
            >
              {this.replaceSpacesToNbsp(newbuilding.specialStatusDisplay)}
              {newbuilding.firstMaterial && ` ${MIDDLE_DOT}${NO_BREAK_SPACE}${newbuilding.firstMaterial.name}`}
              {newbuilding.isFz_214 && ` ${MIDDLE_DOT}${NO_BREAK_SPACE}Оформление по${NO_BREAK_SPACE}214-ФЗ`}
            </Text>
          </Container>
          <div>
            {getMetroInfo(newbuilding)}
            {
              newbuilding.seoGeoDistance && newbuilding.undergroundInfo &&
              <Text color="gray_4">{NO_BREAK_SPACE}{MIDDLE_DOT}{SPACE_SYMBOL}</Text>
            }
            {getGeoDistance(newbuilding, urlFinisher)}
            <Container
              margin={`${SIZE_4} 0`}
              dataMark="CellAddressBlock"
            >
              {newbuilding.addressLine &&
              newbuilding.addressLine.map(({ title, fullUrl, qs }, index) =>
                <React.Fragment key={index}>
                  {!!index && `,${SPACE_SYMBOL}`}
                  <Link
                    url={fullUrl || `/newobjects/list?${qs}`}
                    target="blank"
                  >
                    <Text
                      color="black"
                      colorHovered="red"
                      whiteSpace="nowrap"
                    >
                      {title}
                    </Text>
                  </Link>
                </React.Fragment>,
              )}
            </Container>
          </div>
          <Container
            height={SIZE_40}
            overflow="hidden"
          >
            <Text
              display="inline-block"
              rowEllipsis
            >
              <span
                dangerouslySetInnerHTML={{ __html: this.getDescription(newbuilding.description) }}
              />
            </Text>
          </Container>
          <Advertises
            fromAgentsPropsCount={newbuilding.fromAgentsPropsCount}
            fromDeveloperPropsCount={newbuilding.fromDeveloperPropsCount}
            fromDevelopersRooms={newbuilding.fromDevelopersRooms}
          />
          <Container margin={`${SIZE_12} 0 0`}>
            <RoomCounts
              fromDeveloperPropsLink={newbuilding.fromDeveloperPropsLink}
              fromAgentsPropsLink={newbuilding.fromAgentsPropsLink}
              fromAgentsPropsCount={newbuilding.fromAgentsPropsCount}
              fromAgentsCountsDisplay={newbuilding.fromAgentsCountsDisplay}
              fromDeveloperPropsCount={newbuilding.fromDeveloperPropsCount}
            />
            <Container
              margin={`0 ${SIZE_8} 0 0`}
              display="inline"
              float="left"
              noPrint
            >
              <ShowPhoneButtonContainer
                onShowPhonesClick={onPhoneButtonClick}
                onPhoneClick={trackingOnPhoneClick}
                builders={newbuilding.builders}
                sellers={newbuilding.sellers}
                newbuildingId={newbuilding.id}
              />
              <FavoriteButton
                isFavorite={Boolean(newbuilding.isFavorite)}
                newbuildingId={newbuilding.id}
                gaLabelFull={newbuilding.gaLabels.full}
              />
            </Container>
          </Container>
        </Container>
        <Container width={this.props.isMobile ? SIZE_160 : SIZE_216} flex="0 0 auto" position={'relative'}>
          {isNewbuildingInLeadFactory(newbuilding)
            ? <CianInfo
              sellers={newbuilding.sellers}
              newbuildingId={newbuilding.id}
              fromDeveloperPropsCount={newbuilding.fromDeveloperPropsCount}
            />
            : <BuilderInfo
              builders={newbuilding.builders}
              sellers={newbuilding.sellers}
              newbuildingId={newbuilding.id}
              fromDeveloperPropsCount={newbuilding.fromDeveloperPropsCount}
            />
          }
        </Container>
      </Container>
    );
  }
  private getDescription = (text: string) => (text || '').replace(/<h3.*?<\/h3>/gm, '');
  private replaceSpacesToNbsp = (text: string) => (text || '').replace(new RegExp(' ', 'g'), NO_BREAK_SPACE);
}
const mapStateToProps = (state: IApplicationState): IGKCardStoreProps => {
  return {
    isMobile: state.media.mobile,
    salesLeaderFullUrl: state.offersData.salesLeaderFullUrl,
    urlFinisher: state.location.path,
  };
};
function mapDispatchToProps(dispatch: TTypedThunkDispatch, ownProps: IGKCardOwnProps) {
  return {
    trackingOnPhoneClick() {
      dispatch(trackingActionShowPhone(ownProps.newbuilding));
    },
  };
}
export const GKCard = connect(mapStateToProps, mapDispatchToProps)(GKCardComponent);
